import React from 'react';
import RiskButton from './RiskButton';

function LowRiskButton(props) {
    return (
        <RiskButton
            active={props.active}
            buttonText="Low"
            buttonColor="var(--yellow)"
        />
    );
}

export default LowRiskButton;
